import { StaticAssetsApiService } from '../../domain/static-content/static-assets-api.service';
import { STATIC_ASSETS_CACHE_KEY } from '../../util/assets/assets-key';
import { Asset } from '../../domain/static-content/static-assets-api.model';
import { useQuery } from '@tanstack/react-query';

export const useRefreshAssets = (tags?: string[]) => {
  return useQuery<Asset[]>([STATIC_ASSETS_CACHE_KEY], StaticAssetsApiService.getAssetsFetcher(tags || []).fetcher, { enabled: !!tags });
};
